"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKClientVersionService = void 0;
var version_1 = require("../../version");
exports.SDKClientVersionService = {
    version: version_1.version,
};
